import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Helmet } from 'react-helmet';

import * as actions from '../actions';
import Card from './common/SemanticCard';
import Loader from './common/Loader';
import MainContent from './common/MainContent';

class Blogs extends Component {
	state = {};
	componentDidMount() {
		const { blogs, getBlogs } = this.props;
		if (
			process.env.NODE_ENV === 'production' ||
			(process.env.NODE_ENV === 'development' && (!blogs || blogs.length === 0))
		) {
			getBlogs();
		}
	}

	render() {
		const { blogs, history, isLoading } = this.props;
		return (
			<MainContent>
				<Helmet>
					<title>George Kanchev's Blog</title>
					<meta name="description" content={'My blogs are here!'} />
				</Helmet>
				<div className="row d-flex justify-content-center">
					<Loader loading={isLoading} message={'Loading blogs'}>
						{blogs &&
							blogs
								.filter((e) => !e.hide)
								.map((e) => (
									<div className="col-md-4" key={e.id}>
										<Card
											description={e.description}
											header={e.title}
											id={e.id}
											image={`./images/blogs/${e.image}`}
											meta={e.meta}
											extra={{ date: e.datePosted, icon: 'calendar alternate outline' }}
											onClick={() => history.push(`/blogs/${e.id}/${e.shortURL}`)}
										/>
									</div>
								))}
					</Loader>
				</div>
			</MainContent>
		);
	}
}

function mapStateToProps(state) {
	return {
		blogs: state.blogs && state.blogs.data,
		isLoading: state.blogs && state.blogs.isLoading,
	};
}

export default withRouter(
	connect(
		mapStateToProps,
		actions,
	)(Blogs),
);



// WEBPACK FOOTER //
// ./src/components/Blogs.js